import _ from 'lodash';
import * as types from '@/store/types';

const errorModule = {
    state: {
        message: '',
        code: null,
        field_messages: {},
    },

    mutations: {
        [types.ERROR__MUTATE_ERROR](localState, payload) {
            if (!_.isObject(payload.field_messages)) {
                // eslint-disable-next-line no-param-reassign
                payload.field_messages = {};
            }
            _.assign(localState, payload);
        },
    },

    actions: {
        [types.ERROR__SET_ERROR]({ commit, rootState }, { message, code, field_messages = {} }) {
            let errorDisplayMessage = message;
            if (field_messages.email && rootState.contactInfo.email) {
                errorDisplayMessage = `An account for ${rootState.contactInfo.email} already exists.`;
            }

            commit(types.ERROR__MUTATE_ERROR, {
                message: errorDisplayMessage,
                code,
                field_messages,
            });
        },

        [types.ERROR__CLEAR_ERROR]({ commit }) {
            commit(types.ERROR__MUTATE_ERROR, { message: '', code: null, field_messages: {} });
        },
    },

    getters: {},
};

export default errorModule;
